import React from "react";
import useWindowSize from "../../../utils/ScreenSize";
import Header from "../../../Components /HeaderComponent/Header";
import styles from "./LeadingBeverageStudy.module.css";
import CaseStudies from "../../../Components /CaseStudies/CaseStudies";
import FadeInOnScroll from "../../../utils/FadeInOnScroll";


const S3_BASE = process.env.REACT_APP_S3_BASE_URL;

const beverageHeader = `${S3_BASE}/beverageHeader.png`;
const beveragesImg = `${S3_BASE}/beveragesImg.png`;
const amazonBevImg = `${S3_BASE}/amazonBevImg.png`;
const bevImg2 = `${S3_BASE}/bevImg2.png`;
const bevImg3 = `${S3_BASE}/bevImg3.png`;
const bevImg4 = `${S3_BASE}/bevImg4.png`;
const bevImg5 = `${S3_BASE}/tegeriaXAwsImg.png`;

const LeadingBeverageStudy = () => {
  const { width } = useWindowSize();
  const isSmallScreen = width < 768;
  return (
    <div>
      <Header headerTitle="Case Study" />
      <div style={{ flex: 1, backgroundColor: "rgba(244, 245, 247, 1)" }}>
        <div
          style={{
            maxWidth: "1054px",
            width: "100%",
            margin: "0 auto",
            paddingBottom: isSmallScreen ? 40 : 100,
            boxSizing: "border-box",
            overflowX: "hidden",
          }}
        >
          <h1 style={{
            fontSize: isSmallScreen ? 24 : 36,
            fontWeight: 700,
            color: "rgba(27, 49, 94, 1)",
            fontFamily: "Montserrat, sans-serif",
            lineHeight: 1.2,
            padding: isSmallScreen ? "32px 24px 0" : "48px 0 0",
            margin: 0,
          }}>
            Leading Beverage Company Enhances Web Application Performance and Security with AWS
          </h1>

          <FadeInOnScroll
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 24,
              padding: isSmallScreen ? " 0 24px" : "",
              marginTop: isSmallScreen ? 24 : 32,
            }}
          >
            <img
              src={beverageHeader}
              alt="aws header"
              style={{ minHeight: 125, objectFit: "cover" }}
            />
            <div style={{ display: "flex", gap: 24 }}>
              <p>By Tegeria</p>
              <div
                style={{
                  width: 1,
                  borderLeft: "1px solid rgba(125, 137, 176, 1)",
                }}
              />
              <p>Apr 5, 2024</p>
            </div>
          </FadeInOnScroll>
          <section
            className={styles.section}
            style={{ paddingTop: isSmallScreen ? 32 : 54 }}
          >
            <FadeInOnScroll
              animation="fade-right"
              className={styles.sectionContent}
            >
              <h2>Overview</h2>
              <p>
                The customer is a leading entity in the non-alcoholic beverage
                industry. Since 1994, they have been a key player in the market,
                producing and distributing a wide range of popular beverages.
                Their extensive portfolio includes well-known international
                brands, and they are recognized for their significant
                contributions to the local economy. Committed to leveraging
                advanced digital technologies, the customer aims to improve
                operational efficiency and enhance customer engagement.
              </p>
            </FadeInOnScroll>
            <FadeInOnScroll animation="fade-left">
              <img src={beveragesImg} alt="bev img" />
            </FadeInOnScroll>
          </section>

          <section
            className={`${styles.section} ${styles.reverseMobile}`}
            style={{ paddingTop: isSmallScreen ? 40 : 90 }}
          >
            <FadeInOnScroll animation="fade-right">
              <img src={amazonBevImg} alt="amazon img" />
            </FadeInOnScroll>
            <FadeInOnScroll
              animation="fade-left"
              className={styles.sectionContent}
            >
              <h2>The Challenge</h2>
              <p>
                The customer faced a multifaceted challenge in optimizing their
                React.JS web application. They needed a solution that was both
                cost-effective and highly available, designed to boost
                performance while efficiently managing cache utilization. The
                existing system struggled with performance issues, particularly
                under high traffic volumes, leading to slow load times and a
                subpar user experience. Additionally, they required stringent
                access controls to restrict site access to a specific list of
                client IP addresses, all without the need for complex networking
                configurations. Addressing these challenges was crucial for
                improving the user experience and ensuring robust security.
              </p>
            </FadeInOnScroll>
          </section>

          <div
            className={styles.sectionContent}
            style={{
              padding: isSmallScreen && 24,
              marginTop: isSmallScreen ? 40 : 100,
            }}
          >
            <h2>The Solution</h2>
            <p>
              To meet the customer’s needs, we implemented a comprehensive and
              scalable AWS-based solution tailored to their specific
              requirements:
            </p>
          </div>

          <section
            className={styles.section}
            style={{ paddingTop: isSmallScreen ? 40 : 90 }}
          >
            <div
              className={styles.sectionContent}
              style={{ gap: 40, paddingTop: 12 }}
            >
              <FadeInOnScroll animation="fade-right">
                <h2>Hosting with Amazon S3:</h2>
                <p>
                  We used Amazon S3 to host the static content of the customer’s
                  React.JS application. The static website hosting feature of
                  Amazon S3 provided a reliable foundation for serving web
                  content. This setup offered cost-effective storage and high
                  availability, with S3’s architecture ensuring fault tolerance
                  and automatic scaling. This allowed the customer to handle
                  varying traffic levels without compromising performance. The
                  ease of integration with other AWS services also streamlined
                  the deployment process and facilitated efficient management of
                  static assets.
                </p>
              </FadeInOnScroll>
              <FadeInOnScroll animation="fade-right">
                <h2>Advanced Security with AWS WAF:</h2>
                <p>
                  For stringent access control, we deployed AWS WAF (Web
                  Application Firewall) to manage IP-based restrictions. Using
                  AWS WAF’s Rule Builder, we created a custom rule that
                  permitted traffic only from a specified set of whitelisted IP
                  addresses. This setup effectively blocked any requests not
                  originating from these approved IP addresses, ensuring that
                  only authorized users could access the web application. The
                  AWS WAF solution was designed to be user-friendly, avoiding
                  the need for complex networking knowledge while providing
                  robust security.
                </p>
              </FadeInOnScroll>
              <FadeInOnScroll animation="fade-right">
                <h2>Integration and Testing: </h2>
                <p>
                  Throughout the implementation, we conducted thorough testing
                  to ensure seamless integration between S3, CloudFront, and
                  WAF. This included validating that the CDN effectively cached
                  and delivered content as expected and that access controls
                  were enforced accurately. We also worked closely with the
                  customer to configure and fine-tune settings based on their
                  specific traffic patterns and security requirements.
                </p>
              </FadeInOnScroll>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                gap: 16,
              }}
            >
              <FadeInOnScroll animation="fade-left">
                <img src={bevImg2} alt="bev img 2" />
              </FadeInOnScroll>
              <FadeInOnScroll animation="fade-left">
                <img src={bevImg3} alt="bev img 3" />
              </FadeInOnScroll>
            </div>
          </section>

          <section
            className={`${styles.section} ${styles.reverseMobile}`}
            style={{ paddingTop: isSmallScreen ? 40 : 100 }}
          >
            <FadeInOnScroll animation="fade-right">
              <img src={bevImg4} alt="bev img 4" />
            </FadeInOnScroll>
            <FadeInOnScroll
              animation="fade-left"
              className={styles.sectionContent}
            >
              <h2>The Outcomes</h2>
              <p>
                The AWS-based solution brought significant improvements to the
                customer’s web application. Performance was notably enhanced,
                with page load times reduced by up to 60% due to CloudFront’s
                efficient content delivery. Scalability and reliability were
                greatly improved, allowing the website to handle high traffic
                volumes smoothly. Security was reinforced with AWS WAF, which
                successfully restricted access to only the whitelisted IP
                addresses, mitigating potential threats. Additionally, the
                cost-effective nature of S3 and CloudFront resulted in a
                reduction in hosting and operational costs by approximately 40%,
                providing substantial savings while meeting all performance and
                security requirements.
              </p>
            </FadeInOnScroll>
          </section>

          <section
            className={styles.section}
            style={{ paddingTop: isSmallScreen ? 40 : 100 }}
          >
            <FadeInOnScroll
              animation="fade-right"
              className={styles.sectionContent}
            >
              <h2>About the Partner</h2>
              <p>
                Tegeria is a global digital transformation company with a center
                of excellence in Europe. Our expertise lies in creating
                high-performance, scalable, and secure AWS infrastructures
                tailored to meet the unique needs of our clients. With a focus
                on delivering technical excellence and ensuring customer
                success, Tegeria helps businesses like the beverage company
                achieve their digital transformation goals efficiently and
                effectively. Our deep understanding of AWS services and proven
                track record make us a trusted partner in leveraging AWS for
                optimal results.
              </p>
            </FadeInOnScroll>
            <FadeInOnScroll animation="fade-left">
              <img src={bevImg5} alt="tegeria x aws img" />
            </FadeInOnScroll>
          </section>
        </div>
        <CaseStudies />
      </div>
    </div>
  );
};

export default LeadingBeverageStudy;
